/* Glamora Beauty — theme.js
   Vanilla JS, no dependencies. Every feature degrades to native Shopify forms/links without JS. */
(function () {
  'use strict';

  var T = window.theme || { routes: {} };
  var R = T.routes;

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function reducedMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function define(name, cls) { if (!customElements.get(name)) customElements.define(name, cls); }

  function jsonFetch(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data }; });
    });
  }

  /* ---------- Cart state helpers ---------- */
  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
    qsa('[data-cart-toggle]').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items')); });
  }

  function cartSectionIds() {
    var ids = qsa('cart-items[data-section-id]').map(function (el) { return el.dataset.sectionId; });
    return ids.filter(function (id, i) { return ids.indexOf(id) === i; });
  }

  function renderSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var fresh = qs('[data-section-content]', parseHTML(html));
      var target = qs('#shopify-section-' + id + ' [data-section-content]') ||
        qs('cart-items[data-section-id="' + id + '"] [data-section-content]');
      if (fresh && target) target.innerHTML = fresh.innerHTML;
    });
  }

  function getDrawer() { return document.getElementById('CartDrawer'); }

  function openDrawer() {
    var d = getDrawer();
    if (!d) return false;
    if (!d.open) {
      d.showModal();
      document.body.classList.add('is-locked');
    }
    return true;
  }

  function closeDrawer() {
    var d = getDrawer();
    if (d && d.open) d.close();
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && T.cartType === 'drawer' && getDrawer() && document.body.className.indexOf('template-cart') === -1) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-close-drawer]')) closeDrawer();
    var d = getDrawer();
    if (d && e.target === d) closeDrawer(); // backdrop click
  });

  document.addEventListener('close', function (e) {
    if (e.target && e.target.id === 'CartDrawer') document.body.classList.remove('is-locked');
  }, true);

  /* ---------- Ajax add to cart (falls back to native POST /cart/add) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (T.cartType !== 'drawer' || !getDrawer()) return;
    e.preventDefault();

    var btn = e.submitter || qs('[type="submit"]', form);
    var errorEl = qs('[data-form-error]', form);
    var fd = new FormData(form);
    var ids = cartSectionIds();
    fd.append('sections', ids.join(','));
    fd.append('sections_url', window.location.pathname);
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    if (errorEl) errorEl.hidden = true;

    jsonFetch(R.cart_add_url + '.js', {
      method: 'POST',
      body: fd,
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        if (!r.ok) {
          if (errorEl) { errorEl.textContent = r.data.description || r.data.message || 'This item could not be added.'; errorEl.hidden = false; }
          return;
        }
        renderSections(r.data.sections);
        return fetch(R.cart_url + '.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) { updateCartCount(cart.item_count); openDrawer(); });
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
  });

  /* ---------- Quantity input ---------- */
  define('quantity-input', class extends HTMLElement {
    connectedCallback() {
      this.input = qs('input', this);
      this.addEventListener('click', (e) => {
        var b = e.target.closest('[data-step]');
        if (!b || !this.input) return;
        var step = Number(this.input.step) || 1;
        var min = this.input.min !== '' ? Number(this.input.min) : 0;
        var max = this.input.max !== '' ? Number(this.input.max) : Infinity;
        var next = (Number(this.input.value) || 0) + Number(b.dataset.step) * step;
        next = Math.max(min, Math.min(max, next));
        if (next === Number(this.input.value)) return;
        this.input.value = next;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });

  /* ---------- Cart items (page + drawer) ---------- */
  define('cart-items', class extends HTMLElement {
    connectedCallback() {
      this.status = qs('[data-cart-status]', this);
      this.debounce = null;
      this.addEventListener('change', (e) => {
        var t = e.target;
        if (t.matches('[data-qty-input]')) {
          clearTimeout(this.debounce);
          this.debounce = setTimeout(() => this.update(t.dataset.line, t.value), 300);
        } else if (t.matches('[data-cart-note]')) {
          fetch(R.cart_update_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: t.value }) });
        }
      });
      this.addEventListener('click', (e) => {
        var rm = e.target.closest('[data-remove]');
        if (rm) { e.preventDefault(); this.update(rm.dataset.line, 0); }
      });
    }
    update(line, quantity) {
      this.classList.add('is-busy');
      jsonFetch(R.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: cartSectionIds(), sections_url: window.location.pathname })
      })
        .then((r) => {
          if (!r.ok) {
            if (this.status) this.status.textContent = r.data.description || r.data.message || 'Your bag could not be updated.';
            window.alert(r.data.description || r.data.message || 'Your bag could not be updated.');
            renderSections(null);
            return;
          }
          renderSections(r.data.sections);
          updateCartCount(r.data.item_count);
          if (this.status) this.status.textContent = 'Bag updated. ' + r.data.item_count + ' items.';
        })
        .catch(function () { window.location.reload(); })
        .finally(() => this.classList.remove('is-busy'));
    }
  });

  /* ---------- Details-based menus (mobile drawer, search) ---------- */
  document.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-close-details]');
    if (closer) {
      var det = closer.closest('details');
      if (det) { det.removeAttribute('open'); var s = qs('summary', det); if (s) s.focus(); }
    }
    qsa('details[data-search-modal][open], details[data-menu-drawer][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    qsa('details[data-search-modal][open], details[data-menu-drawer][open]').forEach(function (d) {
      d.removeAttribute('open'); var s = qs('summary', d); if (s) s.focus();
    });
    qsa('facets-drawer.is-open').forEach(function (f) { f.close(); });
  });
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!(d instanceof HTMLDetailsElement)) return;
    if (d.matches('[data-search-modal]') && d.open) { var i = qs('input[type="search"]', d); if (i) setTimeout(function () { i.focus(); }, 30); }
    if (d.matches('[data-menu-drawer]')) document.body.classList.toggle('is-locked', d.open);
  }, true);

  /* ---------- Predictive search ---------- */
  define('predictive-search', class extends HTMLElement {
    connectedCallback() {
      if (!T.predictiveSearch) return;
      this.input = qs('input[type="search"]', this);
      this.results = qs('[data-predictive-results]', this);
      this.statusEl = qs('[data-predictive-status]', this);
      this.timer = null;
      this.controller = null;
      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.search(this.input.value.trim()), 250);
      });
      this.input.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.hide(); });
      document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.hide(); });
    }
    search(q) {
      if (!q) { this.hide(); return; }
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      var url = R.predictive_search_url + '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search&resources[type]=product,collection,page,article,query&resources[limit]=4&resources[options][unavailable_products]=last';
      fetch(url, { signal: this.controller.signal })
        .then(function (r) { return r.text(); })
        .then((html) => {
          var inner = qs('.predictive__inner', parseHTML(html));
          if (!inner) { this.hide(); return; }
          this.results.innerHTML = inner.outerHTML;
          this.results.hidden = false;
          this.input.setAttribute('aria-expanded', 'true');
          var n = inner.getAttribute('data-predictive-count') || '0';
          if (this.statusEl) this.statusEl.textContent = n + ' suggestions available';
        })
        .catch(function () {});
    }
    hide() {
      if (!this.results) return;
      this.results.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
    }
  });

  /* ---------- Announcement rotator ---------- */
  define('announcement-rotator', class extends HTMLElement {
    connectedCallback() {
      this.items = qsa('.announcement__item', this);
      if (this.items.length < 2 || reducedMotion()) return;
      this.i = 0;
      var ms = (Number(this.dataset.interval) || 5) * 1000;
      this.timer = setInterval(() => this.next(), ms);
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
      this.addEventListener('focusin', () => clearInterval(this.timer));
    }
    next() {
      this.items[this.i].classList.remove('is-active');
      this.items[this.i].setAttribute('aria-hidden', 'true');
      this.i = (this.i + 1) % this.items.length;
      this.items[this.i].classList.add('is-active');
      this.items[this.i].removeAttribute('aria-hidden');
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });

  /* ---------- Hero slider ---------- */
  define('hero-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = qsa('[data-slide]', this);
      this.dots = qsa('[data-dot]', this);
      if (this.slides.length < 2) return;
      this.index = 0;
      this.dots.forEach((d) => d.addEventListener('click', () => { this.go(Number(d.dataset.dot)); this.stop(); }));
      if (this.dataset.autoplay === 'true' && !reducedMotion()) {
        this.start();
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('focusin', () => this.stop());
      }
      document.addEventListener('shopify:block:select', (e) => {
        var i = this.slides.indexOf(e.target);
        if (i > -1) { this.stop(); this.go(i); }
      });
    }
    start() { var ms = (Number(this.dataset.speed) || 6) * 1000; this.timer = setInterval(() => this.go((this.index + 1) % this.slides.length), ms); }
    stop() { clearInterval(this.timer); }
    go(i) {
      this.slides.forEach(function (s, n) {
        var on = n === i;
        s.classList.toggle('is-active', on);
        if (on) { s.removeAttribute('aria-hidden'); s.removeAttribute('inert'); }
        else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('inert', ''); }
      });
      this.dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      this.index = i;
    }
    disconnectedCallback() { this.stop(); }
  });

  /* ---------- Carousel arrows ---------- */
  define('carousel-nav', class extends HTMLElement {
    connectedCallback() {
      this.track = qs('[data-track]', this);
      this.prev = qs('[data-dir="-1"]', this);
      this.next = qs('[data-dir="1"]', this);
      if (!this.track || !this.prev) return;
      var self = this;
      [this.prev, this.next].forEach(function (b) {
        b.addEventListener('click', function () {
          self.track.scrollBy({ left: Number(b.dataset.dir) * self.track.clientWidth * 0.9, behavior: reducedMotion() ? 'auto' : 'smooth' });
        });
      });
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      window.addEventListener('resize', () => this.sync());
      var img = qs('.card__media', this.track);
      if (img) this.style.setProperty('--btn-top', (img.offsetHeight / 2 - 21) + 'px');
      this.sync();
    }
    sync() {
      var t = this.track;
      this.prev.disabled = t.scrollLeft <= 2;
      this.next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
      var img = qs('.card__media', t);
      if (img) this.style.setProperty('--btn-top', (img.offsetHeight / 2 - 21) + 'px');
    }
  });

  /* ---------- Facets drawer (mobile) + auto-submit ---------- */
  define('facets-drawer', class extends HTMLElement {
    connectedCallback() {
      this.opener = qs('[data-facets-open="' + this.id + '"]');
      if (this.opener) this.opener.addEventListener('click', () => this.open());
      var overlay = this.nextElementSibling;
      qsa('[data-facets-close]', this).concat(overlay && overlay.matches('[data-facets-close]') ? [overlay] : [])
        .forEach((b) => b.addEventListener('click', () => this.close()));
    }
    open() {
      this.classList.add('is-open');
      document.body.classList.add('is-locked');
      if (this.opener) this.opener.setAttribute('aria-expanded', 'true');
      var f = qs('summary, input, button', this); if (f) f.focus();
    }
    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('is-locked');
      if (this.opener) { this.opener.setAttribute('aria-expanded', 'false'); this.opener.focus(); }
    }
  });

  document.addEventListener('change', function (e) {
    var form = e.target.form;
    if (!form || !form.hasAttribute('data-facets-form')) return;
    var drawer = form.closest('facets-drawer');
    if (drawer && drawer.classList.contains('is-open')) return; // apply via "Show results" on mobile
    form.requestSubmit ? form.requestSubmit() : form.submit();
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.hasAttribute('data-facets-form')) return;
    qsa('input[type="number"]', form).forEach(function (i) { if (i.value === '') i.disabled = true; });
  });

  /* ---------- Product gallery ---------- */
  define('media-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = qs('[data-slides]', this);
      this.slides = qsa('.gallery__slide', this);
      this.thumbs = qsa('[data-thumb]', this);
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(Number(t.dataset.thumb))));
      if (this.track) this.track.addEventListener('scroll', () => {
        clearTimeout(this.st);
        this.st = setTimeout(() => {
          var i = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
          this.mark(i);
        }, 60);
      }, { passive: true });
    }
    goTo(i) {
      var s = this.slides[i];
      if (!s) return;
      if (this.track.scrollWidth > this.track.clientWidth + 2) {
        this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft, behavior: reducedMotion() ? 'auto' : 'smooth' });
      } else {
        window.scrollTo({ top: s.getBoundingClientRect().top + window.scrollY - 120, behavior: reducedMotion() ? 'auto' : 'smooth' });
      }
      this.mark(i);
    }
    showMedia(id) {
      var i = this.slides.findIndex(function (s) { return s.dataset.mediaId === String(id); });
      if (i > -1) this.goTo(i);
    }
    mark(i) {
      this.thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    }
  });

  /* ---------- Product info: variant selection ---------- */
  define('product-info', class extends HTMLElement {
    connectedCallback() {
      var data = qs('script[data-variants]', this);
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.sectionId = this.dataset.section;
      this.form = document.getElementById('product-form-' + this.sectionId);
      this.addEventListener('change', (e) => { if (e.target.closest('[data-option]')) this.onChange(); });
    }
    selected() {
      return qsa('[data-option]', this).map(function (g) {
        var c = qs('input:checked', g); var s = qs('select', g);
        return c ? c.value : (s ? s.value : null);
      });
    }
    setButtons(enabled, label) {
      qsa('[data-add-button], sticky-atc[data-for="' + this.sectionId + '"] button').forEach(function (b) {
        b.disabled = !enabled; b.textContent = label;
      });
    }
    onChange() {
      var opts = this.selected();
      qsa('[data-option]', this).forEach(function (g, i) { var l = qs('[data-selected-label]', g); if (l) l.textContent = opts[i]; });
      var v = this.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      if (!v) { this.setButtons(false, 'Unavailable'); return; }
      if (this.form) { var idInput = qs('input[name="id"]', this.form); if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); } }
      this.setButtons(v.available, v.available ? 'Add to cart' : 'Sold out');
      window.history.replaceState({}, '', this.dataset.url + '?variant=' + v.id);
      if (v.featured_media) { var g = qs('media-gallery', this); if (g && g.showMedia) g.showMedia(v.featured_media.id); }
      var requested = v.id;
      this.current = requested;
      fetch(this.dataset.url + '?variant=' + v.id + '&section_id=' + this.sectionId)
        .then(function (r) { return r.text(); })
        .then((html) => {
          if (this.current !== requested) return;
          var doc = parseHTML(html);
          qsa('[data-variant-update]', doc).forEach(function (fresh) {
            var key = fresh.getAttribute('data-variant-update');
            qsa('[data-variant-update="' + key + '"]').forEach(function (t) { t.innerHTML = fresh.innerHTML; });
          });
        })
        .catch(function () {});
    }
  });

  /* ---------- Sticky add to cart (mobile) ---------- */
  define('sticky-atc', class extends HTMLElement {
    connectedCallback() {
      var target = qs('[data-main-buy]');
      if (!target || !('IntersectionObserver' in window)) return;
      var btn = qs('button', this);
      this.io = new IntersectionObserver((entries) => {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = qs('button', this); if (b) b.tabIndex = show ? 0 : -1;
      });
      this.io.observe(target);
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
  });

  /* ---------- Product recommendations ---------- */
  define('product-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.loaded || !this.dataset.url) return;
      var load = () => {
        this.loaded = true;
        fetch(this.dataset.url).then(function (r) { return r.text(); }).then((html) => {
          var fresh = qs('product-recommendations', parseHTML(html));
          if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
        }).catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(this);
      } else { load(); }
    }
  });
})();
